import { exportReportFile } from "../ReportDetails/Report.Api";
import { deletion, get, post, put } from "../Service/ApiConfig";
import {
  ConvenienceFee,
  ProviderEndPoint,
  TransactionEndPoints,
} from "../Service/Endpoints/ApiEndPoints";

const REPORT_EXPORT_NAME = "FinanceTransactions";
const REPORT_EXPORT_FILE_TYPE = "xlsx";

const createTransactionsExportPayload = ({
  reportName = REPORT_EXPORT_NAME,
  fileType = REPORT_EXPORT_FILE_TYPE,
  startDate = null,
  endDate = null,
  searchString = null,
  providerId = null,
} = {}) => {
  if (
    reportName !== REPORT_EXPORT_NAME ||
    fileType !== REPORT_EXPORT_FILE_TYPE
  ) {
    throw new Error("Unsupported report export request.");
  }

  return {
    reportName,
    fileType,
    startDate,
    endDate,
    searchString,
    providerId,
  };
};

// --------------------------- Start => Promo code related ----------------------------

export const getAllDoctorsAndPromoCodeTypes = async () => {
  const response = await get(
    TransactionEndPoints.getAllDoctorsAndPromoCodeTypes,
  );
  return response;
};

export const getActiveProviders = async () => {
  const response = await get(TransactionEndPoints.getActiveProviders);
  return response;
};

export const getAllPromoCodes = async (pageNumber, pageSize) => {
  const response = await get(
    TransactionEndPoints.getAllPromoCodes(pageNumber, pageSize),
  );
  return response;
};

export const addPromoCode = async (formValues) => {
  const response = await post(TransactionEndPoints.addPromoCode, formValues);
  return response;
};

export const updatePromoCode = async (id, formValues) => {
  const response = await put(
    TransactionEndPoints.updatePromoCode(id),
    formValues,
  );
  return response;
};

export const removePromoCode = async (id) => {
  const response = await deletion(TransactionEndPoints.removePromoCode(id));
  return response;
};

// ----------------------------- End => Promo code related ----------------------------

// --------------------------- Start => Transactions related --------------------------

export const getAllTransactions = async (
  pageNumber,
  pageSize,
  searchString,
  startDate,
  endDate,
) => {
  const response = await get(
    TransactionEndPoints.getAllTransactions(
      pageNumber,
      pageSize,
      searchString,
      startDate,
      endDate,
    ),
  );
  return response;
};

export const exportTransactions = async (payload) => {
  const response = await exportReportFile(
    createTransactionsExportPayload(payload),
  );
  return response;
};

export const getTransactionRelatedData = async () => {
  const response = await get(TransactionEndPoints.getTransactionRelatedData());
  return response;
};

export const getTransactionsByProvider = async (
  pageNumber,
  pageSize,
  providerId,
  searchString,
  startDate,
  endDate,
) => {
  const response = await get(
    TransactionEndPoints.getTransactionsByProvider(
      pageNumber,
      pageSize,
      providerId,
      searchString,
      startDate,
      endDate,
    ),
  );
  return response;
};
// --------------------------- End => Transactions related ----------------------------

//* Tax Api Calls

/**
 * this api will add tax
 * @param: tax => tax name
 * @param: value=> tax value
 *  */
export const addTax = async ({ tax, value }) => {
  let body = {
    Name: tax,
    Percentage: value,
  };
  const response = await post(TransactionEndPoints.addTax, body);
  return response;
};

/**
 * this api will update tax
 * @param: tax => tax name
 * @param: value=> tax value
 * @param: id=> id of the tax which going to get update
 *  */
export const updateTax = async ({ tax, value, id }) => {
  let body = {
    id: id,
    name: tax,
    percentage: value,
    isActive: true,
  };
  const response = await put(TransactionEndPoints.updateTax, body);
  return response;
};

// this api will retrieve taxes
export const getAllTax = async () => {
  const response = await get(TransactionEndPoints.getAllTaxes);
  return response;
};

/**
 * this api will remove the tax with tax id
 * @param: id=> id of the tax which going to get removed
 *  */
export const removeTax = async ({ id }) => {
  const response = await deletion(TransactionEndPoints.removeTax(id));
  return response;
};

//* Convienience fee Api Calls

// this api will retrieve Convience Fee
export const getConvienceFee = async () => {
  const response = await get(ConvenienceFee.route);
  return response;
};

// this api will retrieve all active providers
export const getAllActiveProviders = async () => {
  const response = await get(ProviderEndPoint.getAllActiveProviders);
  return response;
};

/**
 * this api will add the Convience fee
 * @param: fee=> new Convience fee
 *  */
export const postConvienceFee = async (data) => {
  let body = {
    providerId: data.providerId,
    providerName: data.providerName,
    name: data.name,
    type: data.type,
    percentage: data.percentage,
    amount: data.amount,
    isActive: data.isActive,
  };
  const response = await post(ConvenienceFee.route, body);
  return response;
};

/**
 * this api will update convienience Fee
 * @param: value=> convienience fee
 * @param: id=> id of the convienience fee which going to get update
 *  */
export const putConvienceFee = async (data) => {
  let body = {
    id: data.id,
    providerId: data.providerId,
    providerName: data.providerName,
    name: data.name,
    type: data.type,
    percentage: data.percentage,
    amount: data.amount,
    isActive: data.isActive,
  };
  const response = await put(ConvenienceFee.route, body);
  return response;
};

/**
 * this api will remove the Convience Fee
 * @param: id=> id of the convienience fee which going to get removed
 *  */
export const deleteConvienceFee = async (id) => {
  const response = await deletion(ConvenienceFee.routetwo(id));
  return response;
};

//* Consultation fee Api Calls

// this api will retrieve get the consultation fee
export const getConsultationFee = async () => {
  const response = await get(TransactionEndPoints.consultationFee);
  return response;
};

/**
 * this api will add the consultation fee
 * @param: fee=> new consultation fee
 *  */
export const postConsultationFee = async (data) => {
  const response = await post(TransactionEndPoints.consultationFee, data);
  return response;
};

/**
 * this api will update the consultation fee
 * @param: id=> id of the consultation fee which going to get update
 * @param: fee=> new consultation fee
 *  */
export const putConsultationFee = async (data) => {
  const response = await put(TransactionEndPoints.consultationFee, data);
  return response;
};

/**
 * this api will remove the consultation fee
 * @param: id=> id of the consultation fee which going to get removed
 *  */
export const deleteConsultationFee = async (id) => {
  const response = await deletion(
    TransactionEndPoints.removeConsultationFee({ id: id }),
  );
  return response;
};
